import React from "preact";
import { useState } from "preact/hooks";
import { DeleteOutlined } from "@ant-design/icons";
import { EllipsisOutlined } from "@ant-design/icons";
import CropImageIcon from "../icon/CropImageIcon";
import ADAIcon from "../icon/ADAIcon";
import util from "../../util";
import FavoriteButton from "../FavoriteButton";
import imageService from "../../service/imageService";
import constants from "../../constants";

interface UploadImageCardProps {
  image: any;
  uploadedImages: any[];
  setUploadedImages: (images: any[]) => void;
  openCropper: (image: any, event: any) => void;
  openAltTextModal: (image: any, event: any) => void;
  isFavorite?: boolean;
  showActions?: boolean;
  toggleFavoriteCallback?: () => void;
  removeImageCallback?: () => void;
}

export default function UploadImageCard({ image, uploadedImages, setUploadedImages, openCropper, openAltTextModal, isFavorite = false, showActions = true, toggleFavoriteCallback, removeImageCallback }: UploadImageCardProps) {

  const [isLoading, setIsLoading] = useState(false);

  function handleMenuToggle(event: any) {
    const menuToggle = event.currentTarget;
    const dropdownMenu = menuToggle.nextElementSibling;
    const componentRect = $(menuToggle).closest('.component-wrapper')[0]!.getBoundingClientRect();
    const containerRect = document.querySelector('.masonry-grid')!.getBoundingClientRect();

    // Check if there's enough space on the right
    const spaceOnRight = containerRect.right - componentRect.right;
    // Assuming dropdown menu width is 150px, adjust this value as needed
    if (spaceOnRight < 150) {
      dropdownMenu.style.left = 'auto';
      dropdownMenu.style.right = '0';
    } else {
      dropdownMenu.style.left = '0';
      dropdownMenu.style.right = 'auto';
    }
  }

  function removeImage(image: any, event: any) {
    event.stopPropagation();

    (window as any).ConfirmationModal.show({
      title: 'Are you sure?',
      body: 'This image will be removed from your gallery.',
      acceptLabel: 'Ok',
      declineLabel: 'Cancel',
      onAccept: () => {
        imageService.removeMemberImage(image.id).then(response => {
          setUploadedImages(uploadedImages.filter(it => it.id !== image.id))
          setTimeout(() => {
            removeImageCallback?.();
          }, 100)
        })
      },
      onDecline: () => {
        (window as any).ConfirmationModal.hide()
      }
    })
  }

  if (image.isMp4 || image.isWebM) {
    const component = <div className="component-wrapper">
      <div className="component template video-frame" data-component="video-frame" data-asset-id={image.id}>
        <div className="frame" data-component="video-frame" data-type="video-frame" style="display: table-row;" data-asset-id={image.id}>
          <div className="video" style={`width: 100%; height: 100%;`} data-original-bg-video={util.getUploadedImgSrc(image)} role="img" aria-label={image.altText}
            dangerouslySetInnerHTML={{
              __html:
                `<video 
               loop muted disablepictureinpicture playsinline 
               src=${util.getUploadedImgSrc(image)}  
               style="width: 100%; height: 100%; object-fit: cover;" />`
            }} />

          {showActions && (
            <div className={`actions ${!image.isOld ? "remove" : "hidden"}`}>
              <div className="dropdown menu-container">
                <div
                  className="dropdown-toggle menu-toggle"
                  onClick={handleMenuToggle}
                >
                  <EllipsisOutlined />
                </div>
                <div className="dropdown-menu">
                  <ul>
                    <li onClick={(event) => openAltTextModal(image, event)}>
                      <ADAIcon color="#000" /> ADA Text
                    </li>
                    <li onClick={(event) => removeImage(image, event)}>
                      <DeleteOutlined /> Delete
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

    return (component);
  } else {
    return (
      <div className="component-wrapper">
        <div className="component template frame" data-component="frame" data-asset-id={image.id}>
          <div className="frame" data-component="frame" data-type="frame" style="display: table-row;" data-asset-id={image.id}>
            <div className="img" data-original-bg-img={util.getUploadedImgSrc(image)} style={`width: 100%; height: 100%;`}>
              <picture>
                <img loading={'lazy'} style="width: 100%; height: 100%;" className="img" src={util.getUploadedImgSrc(image)} alt={image.altText} />
              </picture>
            </div>
          </div>
        </div>

        {showActions && (
          <div className={`actions ${!image.isOld ? "remove" : "hidden"}`}>
            <div className="dropdown menu-container">
              <div
                className="dropdown-toggle menu-toggle"
                onClick={handleMenuToggle}
              >
                <EllipsisOutlined />
              </div>
              <div className="dropdown-menu">
                <ul>
                  <li onClick={(event) => openCropper(image, event)}>
                    <CropImageIcon /> Crop Photo
                  </li>
                  <li onClick={(event) => openAltTextModal(image, event)}>
                    <ADAIcon color="#000" /> ADA Text
                  </li>
                  <li onClick={(event) => removeImage(image, event)}>
                    <DeleteOutlined /> Delete
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

        <FavoriteButton assetId={image.id} type="upload" isFavorite={isFavorite} callback={toggleFavoriteCallback} />
      </div>
    )
  }
}
